import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ion-padding bg-brand-black text-white text-center py-16" }

import {IonButton} from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MaintenanceSheet',
  setup(__props) {

const reload = () => {
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-xl font-semibold mb-2" }, "Under maintenance", -1)),
    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-brand-light-gray mb-6" }, " Pineapple is temporarily unavailable. Please try again soon. ", -1)),
    _createVNode(_unref(IonButton), {
      expand: "block",
      fill: "outline",
      color: "light",
      onClick: reload
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Refresh ", -1)
      ]))]),
      _: 1
    })
  ]))
}
}

})